/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class OrganizationsFavoritesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Favorite (with a sort priority), reorder, or unfavorite (null priority) an organization
     * for the current Helm user.
     * @returns void
     * @throws ApiError
     */
    public updateOrganizationFavorite({
        organization,
        requestBody
    }: {
        /**
         * Organization ID
         */
        organization: number
        requestBody?: {
            /**
             * Sort priority among the user's favorites. Pass null to unfavorite.
             */
            priority: number | null
        }
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/organizations/{organization}/favorite',
            path: {
                organization: organization
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
}
